import { createSlice } from '@reduxjs/toolkit';

export const AssignmentStartEndIntDuration = createSlice({
  name: 'assignmentinterpretedduration',
  initialState: {
    value: 2,
  },
  reducers: {
    SetInterpretedDuration: (state) => {
      state.value = 1
    }
  },
})

export const { SetInterpretedDuration } = AssignmentStartEndIntDuration.actions


export const InterpreteredDurationRedux = (state) => state.assignmentinterpretedduration.value

export default AssignmentStartEndIntDuration.reducer
